import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-action_modal_logout-click';
/**
 * Log out click event in ActionModal
 */
export function trackHelpCenterActionModalLogoutClick(retailerToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { retailerToken, brandToken },
    });
}
